import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7d8d044d = () => interopDefault(import('../pages/compra/index.vue' /* webpackChunkName: "pages/compra/index" */))
const _229478e0 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _5403a7b6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/compra",
    component: _7d8d044d,
    name: "compra___es"
  }, {
    path: "/login",
    component: _229478e0,
    name: "login___es"
  }, {
    path: "/pt",
    component: _5403a7b6,
    name: "index___pt"
  }, {
    path: "/pt/compra",
    component: _7d8d044d,
    name: "compra___pt"
  }, {
    path: "/pt/login",
    component: _229478e0,
    name: "login___pt"
  }, {
    path: "/",
    component: _5403a7b6,
    name: "index___es"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
